<template>
    <div style="background: #fff" class="p-3 h-100" v-if="preg.pregMaster != null">
        <h5 :class="labelClasses">제목</h5>
        <p>{{preg.pregMaster.name}}</p>
        <h5 :class="labelClasses">마켓</h5>
        <p>{{$route.query.market}}</p>
        <h5 :class="labelClasses">사전예약 기간</h5>
        <p style="color: #F53838">{{new Date(preg.pregMaster.startTime).toLocaleString()}} ~ {{new Date(preg.pregMaster.endTime).toLocaleString()}}</p>
        <h5 :class="labelClasses">리스트 공개 일정</h5>
        <b-form v-on:submit.prevent="submitHandling">
            <b-form-group
                    label="시작"
                    label-for="startShowTime" :horizontal="true" :label-cols="1">
                <date-picker id="startShowTime" :value="startShowTime" v-on:input="dateInputHandler($event, 'startShowTime')" :config="dateOptions"></date-picker>
            </b-form-group>
            <b-form-group
                    label="종료"
                    label-for="endShowTime" :horizontal="true" :label-cols="1">
                <date-picker id="endShowTime" :value="endShowTime" v-on:input="dateInputHandler($event, 'endShowTime')" :config="dateOptions"></date-picker>
            </b-form-group>
            <b-row class="align-items-center mt-3">
                <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                    <b-button block variant="outline-primary" type="submit">완료</b-button>
                </b-col>
                <b-col cols="6" sm="4" md="2" xl class="mb-3 mb-xl-0">
                    <b-button block variant="outline-secondary" v-on:click="$router.go(-1)">뒤로</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
<script>
    import gapPregService from '@/common/api/gap.preg.service'
    import { mapGetters, mapMutations } from 'vuex'
    import { MODULE_NAME as PREG_MODULE, FETCH_PREG } from '@/store/preg/actions.type'
    import { labelClasses } from '@/constants'
    import pregService from '@/common/api/preg.service'
    import { $showModalWithErrorMsg } from '@/common/util'
    import { SHOW_MODAL } from '@/store/ui/mutations.type'
    export default {
        name: "GapPregShowListForm",
        mounted () {
            gapPregService.getPregById(this.$route.params.campaignId, this.$route.params.pregId)
                .then(({data}) => {
                    console.log('response')
                    console.log(data)
                    if (data.status === 200) {
                        this.preg = data.data
                        this.$set(this.showListDto, 'pregMasterMarketInfoList', JSON.parse(JSON.stringify(this.preg.marketInfoDtoList)))
                        for (let i = 0; i < this.preg.marketInfoDtoList.length; i++) {
                            // this.preg.marketInfoDtoList[i].startShowTime = this.preg.marketInfoDtoList[i].startShowTime==null? null : new Date(this.preg.marketInfoDtoList[i].startShowTime);
                            // this.preg.marketInfoDtoList[i].endShowTime = this.preg.marketInfoDtoList[i].endShowTime==null? null : new Date(this.preg.marketInfoDtoList[i].endShowTime);
                            if (this.preg.marketInfoDtoList[i].marketType === this.$route.query.market) {
                                this.startShowTime = this.preg.marketInfoDtoList[i].startShowTime === null ? null : new Date(this.preg.marketInfoDtoList[i].startShowTime);
                                this.endShowTime = this.preg.marketInfoDtoList[i].endShowTime === null ? null : new Date(this.preg.marketInfoDtoList[i].endShowTime)
                            }
                        }

                        this.showListDto.pregMasterMarketInfoList.forEach((element) => {
                            if (element.marketType === this.$route.query.market) {
                                element.startShowTime = this.startShowTime
                                element.endShowTime = this.endShowTime
                            }
                        })
                    } else {
                        this.$router.go(-1)
                        alert ('로딩에 실패했습니다.')
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.$router.go(-1)
                    alert('로딩에 실패했습니다.')
                })
        },
        data () {
            return {
                preg: {},
                // 수정 시에 view 용도로 사용할 값
                startShowTime: null,
                endShowTime: null,
                dateOptions: {
                    format: 'YYYY-MM-DD HH:mm:ss',
                    useCurrent: true
                },
                showListDto: {
                    pregMasterMarketInfoList: [{
                        pregMasterId: 0,
                        marketType: null,
                        tmsSendingTime: null,
                        benefitInfo: null,
                        startShowTime: null,
                        endShowTime: null
                    }]
                },
                labelClasses: labelClasses
            }
        },
        computed: {
            ...mapGetters('preg', [
                'pregWithMoment'
            ])
        },
        methods: {
            getMarketIndex(marketStr) {
                if (this.preg != null) {
                    return this.preg.marketInfoDtoList.findIndex((elem) => {
                        return elem.marketType === marketStr
                    })
                } else {
                    return -1
                }
            },
            dateInputHandler (input, property) {
                this.showListDto.pregMasterMarketInfoList.forEach((element) => {
                    if (element.marketType === this.$route.query.market) {
                        element[property] = new Date(input)
                    }
                })
            },
            checkStartDateBeforeEndDate (startDateTime, endDateTime) {
                if (startDateTime === null || endDateTime === null) {
                    return { status: false, msg: '시간을 입력해주세요.' }
                }
                if (startDateTime.getTime() >= endDateTime.getTime()) {
                    return { status: false, msg: '시작일이 종료일보다 빠를 수 없습니다.' }
                }
                if (new Date(this.preg.pregMaster.startTime).getTime() > startDateTime.getTime() ||
                    new Date(this.preg.pregMaster.endTime).getTime() < endDateTime.getTime()) {
                    return { status: false, msg: '리스트 공개 일정은 예약 기간을 벗어날 수 없습니다.' }
                }
                return { status: true, msg: '유효합니다.' }
            },
            getDateValidation () {
                for (let i = 0; i < this.showListDto.pregMasterMarketInfoList.length; i++) {
                    if (this.showListDto.pregMasterMarketInfoList[i].marketType === this.$route.query.market) {
                        return this.checkStartDateBeforeEndDate(this.showListDto.pregMasterMarketInfoList[i].startShowTime, this.showListDto.pregMasterMarketInfoList[i].endShowTime)
                    }
                }
            },
            submitHandling (e) {

                const check = this.getDateValidation();
                if (!check.status) {
                    this[SHOW_MODAL]({msg: check.msg, okHandling: () => {}});
                    return
                }
                // this.showListDto.pregMasterMarketInfoList.forEach((element) => {
                //     element.benefitInfo = JSON.stringify(element.benefitInfo)
                // });

                this.showListDto.gapCampaignId = this.$route.params.campaignId;
                this.showListDto.pregMasterId = this.$route.params.pregId;
                gapPregService.updateShowTime(this.$route.params.campaignId, this.showListDto)
                    .then((res) => {
                        this[SHOW_MODAL]({msg: '수정이 완료되었습니다.', okHandling: () => { this.$router.push({name: 'showListContents'}) }})
                    })
                    .catch($showModalWithErrorMsg.bind(this))
            },
            ...mapMutations('ui', [SHOW_MODAL])
        }
    }
</script>
